import { AxiosResponse } from 'axios'
import Request from '../../redux/config/services/Request'

const getDashboardBulkData = (): Promise<AxiosResponse> => {
  return Request.get('/hr/dashboard/main_metrics/')
}

const getDashboardMapData = (): Promise<AxiosResponse> => {
  return Request.get('/hr/dashboard/recent_trips/')
}

const getDashboardTrackers = (): Promise<AxiosResponse> => {
  return Request.get('/hr/dashboard/employee_trackers/')
}

const getDashboardProgramStats = (): Promise<AxiosResponse> => {
  return Request.get('/hr/dashboard/program_stats/')
}

const getDashboardProgramCards = (): Promise<AxiosResponse> => {
  return Request.get('/hr/dashboard/program_cards/')
}

const getDashboardLocationCards = (): Promise<AxiosResponse> => {
  return Request.get('/hr/dashboard/location_cards/')
}

const getDashboardLocationDetail = (
  locationKey: string
): Promise<AxiosResponse> => {
  return Request.get(
    `/hr/dashboard/location_cards/${encodeURIComponent(locationKey)}/`
  )
}

const getDashboardProgramDetail = (
  launchId: string
): Promise<AxiosResponse> => {
  return Request.get(
    `/hr/dashboard/program_cards/${encodeURIComponent(launchId)}/`
  )
}

const getDashboardTransitExceptions = (): Promise<AxiosResponse> => {
  return Request.get('/hr/profile/transit_exceptions/')
}

const updateDashboardTransitExceptionStatus = ({
  id,
  status,
}: {
  id: string
  status: 'OPEN' | 'RESOLVED'
}): Promise<AxiosResponse> => {
  return Request.patch(`/hr/profile/transit_exceptions/${id}/`, { status })
}

export default {
  getDashboardBulkData,
  getDashboardMapData,
  getDashboardTrackers,
  getDashboardProgramStats,
  getDashboardProgramCards,
  getDashboardLocationCards,
  getDashboardLocationDetail,
  getDashboardProgramDetail,
  getDashboardTransitExceptions,
  updateDashboardTransitExceptionStatus,
}
